import { createUseStyles } from 'react-jss';
import Avatar from '../../assets/Avatar.svg';

export default createUseStyles(
  {
    avatarImage: {
      width: '28px',
      height: '28px',
      backgroundImage: `url(${Avatar})`,
    },
  },
  {
    name: 'Avatar',
  },
);
